// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
//require("../stubs/orderConfiguration/orderConfiguration.less");

import $ from 'jquery';
import run from '../../utilities/run';
import EditChecker from '../../components/EditChecker/EditChecker';
import { setElementsFromScope, setOptionsForSelect } from "../../utilities/selectorHelpers";
import { rgxTest } from "../../utilities/general";
import { calculateCutOffTime } from './utilities';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import {setSwitchery,instantiateSwitchery} from '../../utilities/instantiateSwitchery';

run("#order-config", ()=>{
  const el = $("#order-config");
  orderConfiguration(el);
});

function orderConfiguration(el){
  const internalOrderGracePeriod = el.data("detail-internal-order-domain");
  const channelOrderGracePeriod = el.data("detail-channel-order-domain");
  const defaultAddressValidationLevelsList = el.data("detail-default-address-validation-levels");
  const defaultDomesticShippingMethodsList  = el.data("detail-default-domestic-shipping-methods");
  const internationalOrdersSectionData = el.data("international-orders-domain");
  const productValuesList = el.data("product-values");
  const rtlAddressValidationLevel = el.data("retailer-address-validation-level");
  const rtlDefaultShippingMethod = el.data("retailer-default-shipping-method");
  const orderSplit = el.data("order-split");
  const orderInsufficientInventory = el.data("order-insufficient-inventory");
  const saveURL=el.data("save-order-configuration-url");
  const detailPageUrl=el.data("order-configuration-detail-url");
  const orderDeclaredValue = el.data("order-declared-value");

  const els = {};
  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  const elementsMap = {

    defaultShippingMethodSelect: "#default-shipping-method-select",
    defaultAddressValidationLevelSelect: "#address-validation-level-select",
    addresslevel1text: "#addresslevel1text",
    addresslevel2text: "#addresslevel2text",
    addresslevel0text: "#addresslevel0text",

    orderSplitting: "#orderSplitting",
    insufficientInventory: "#insufficientInventory",
    internalGracePeriodHours: ".internalGracePeriodHours",
    internalGracePeriodMinutes: ".internalGracePeriodMinutes",
    interalOrderCutOffTime: "#interalOrderCutOffTime",

    channelGracePeriodHours: ".channelGracePeriodHours",
    channelGracePeriodMinutes: ".channelGracePeriodMinutes",
    channelOrderCutOffTime: "#channelOrderCutOffTime",

    internalGracePeriodContainer: ".internalGracePeriodContainer",
    channelGracePeriodContainer: ".channelGracePeriodContainer",

    saveOrderConfigModalShow: ".save-order-config",
    saveConfirmationModal: ".save-confirmation-modal",
    saveOrderConfig:".save-order-config-cofirmed",

    errorModal: ".errorModal",

    addressValidationValueHidden: "#display-address-validation-text",
    addressValidationTextHidden: "#display-address-validation-text-meaning",
    shippingMethodValueHidden: "#display-shipping-method-text",
    shippingMethodTextHidden: "#display-shipping-method-text-meaning",

    internationalShipping: "#internationalShipping",
    einNumber: "#einNumber",
    productValueSelect: "#productValue",

    orderDeclaredValueToggleSwitch: "#order-declared-value-switch",
    declaredValue: ".declared-value"

  };

  el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    },
    rules: {
      einNumber: {
        minlength: 10
      }
    },
    messages: {
      einNumber: {
        minlength: "Please enter at least 9 characters."
      }
    }
  });

  function setElements(){
    setElementsFromScope(els, elementsMap, el);
  }

  onLoad();

  function onLoad(){
    setElements();
    setOrderSplittingConfig();
    setOrderInsufficientInventoryConfig();
    setInternalGracePeriod();
    setChannelOrderGracePeriod();
    setInternationalOrderConfig();
    setDeclaredValueOrderConfig();
  }

  setOptionsForSelect({
    selectElement: els.defaultShippingMethodSelect,
    list: defaultDomesticShippingMethodsList,
    valueDataKey: "cdmValue",
    textDataKey: "cdmMeaning",
    initialSelectValue: ()=>{
      return rtlDefaultShippingMethod.cdmValue || /fdx_ground_home_delivery/i;
    }
  });

  setOptionsForSelect({
    selectElement: els.defaultAddressValidationLevelSelect,
    list: defaultAddressValidationLevelsList,
    valueDataKey: "cdmValue",
    textDataKey: "cdmMeaning",
    initialSelectValue: ()=>{
      return rtlAddressValidationLevel.cdmValue || /level2/i;
    }
  });

  setOptionsForSelect({
    selectElement: els.productValueSelect,
    list: productValuesList,
    valueDataKey: "cdmValue",
    textDataKey: "cdmMeaning",
    initialSelectValue: ()=>{
      return internationalOrdersSectionData.productValue || /""/i;
    }
  });


  setAddressValidationTextOnChange(els.defaultAddressValidationLevelSelect.val());
  setShippingMethodTextOnChange(els.defaultShippingMethodSelect.val(), els.defaultShippingMethodSelect.text());

  els.defaultAddressValidationLevelSelect.on('change', function(){
    setAddressValidationTextOnChange(this.value);
  });

  function setAddressValidationTextOnChange(val){
   /* alert(val);
    if(rgxTest(/level1/i, val)){
      els.addresslevel1text.show();
      els.addresslevel2text.hide();
    }else{
      els.addresslevel1text.hide();
      els.addresslevel2text.show();
    }*/
    if(val=='Level1'){
      els.addresslevel1text.show();
      els.addresslevel2text.hide();
      els.addresslevel0text.hide();
    }else if(val=='Level2'){
      els.addresslevel1text.hide();
      els.addresslevel2text.show();
      els.addresslevel0text.hide();
    }else{
      els.addresslevel1text.hide();
      els.addresslevel0text.show();
      els.addresslevel2text.hide();

    }

  }

  els.defaultShippingMethodSelect.on('change', function(){
    setShippingMethodTextOnChange(this.value, $('option:selected', $(this)).text());
  });

  function setShippingMethodTextOnChange(val, text){
    els.shippingMethodValueHidden.val(val);
    els.shippingMethodTextHidden.val(text);
  }

  function setOrderSplittingConfig(){
    if(orderSplit.cdmValue == 1) {
      els.orderSplitting.val("1");
    } else {
      els.orderSplitting.val("0");
    }
  }

  function setInternationalOrderConfig() {
    els.einNumber.val(internationalOrdersSectionData.einNumber);
    if(internationalOrdersSectionData.shippingFlag === true) {
      els.internationalShipping.prop('checked', true);
    }
  }

  function setOrderInsufficientInventoryConfig(){
    if(orderInsufficientInventory.cdmValue == 1) {
      els.insufficientInventory.val("1");
    } else {
      els.insufficientInventory.val("0");
    }
  }

  function setInternalGracePeriod(){
    let hours="";
    let minutes="";
    if((!(typeof internalOrderGracePeriod.cdmValue === "undefined")) || !internalOrderGracePeriod.cdmValue===""){
      hours=parseInt(internalOrderGracePeriod.cdmValue/60);
      minutes=internalOrderGracePeriod.cdmValue%60;
      els.internalGracePeriodHours.val(hours);
      els.internalGracePeriodMinutes.val(minutes);
      els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
      if(hours == 18){
        minutes = 0;
        els.internalGracePeriodMinutes.val(minutes);
        els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
      }

      if(minutes > 0 && hours == 18){
        hours = 17;
        els.internalGracePeriodHours.val(hours);
        els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
      }

    }else{
      hours=0;
      minutes=0;
      els.internalGracePeriodHours.val(hours);
      els.internalGracePeriodMinutes.val(minutes);
      els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
    }

  }

  function setChannelOrderGracePeriod(){
    let hours="";
    let minutes="";
    if((!(typeof channelOrderGracePeriod.cdmValue === "undefined")) || !channelOrderGracePeriod.cdmValue===""){
      hours=parseInt(channelOrderGracePeriod.cdmValue/60);
      minutes=channelOrderGracePeriod.cdmValue%60;
      els.channelGracePeriodHours.val(hours);
      els.channelGracePeriodMinutes.val(minutes);
      els.channelOrderCutOffTime.text(calculateCutOffTime(hours, minutes));

      if(hours == 18){
        minutes = 0;
        els.channelGracePeriodMinutes.val(minutes);
        els.channelOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
      }

      if(minutes > 0 && hours == 18){
        hours = 17;
        els.channelGracePeriodMinutes.val(minutes);
        els.channelOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
      }
    }else{
      hours=0;
      minutes=0;
      els.channelGracePeriodHours.val(hours);
      els.channelGracePeriodMinutes.val(minutes);
      els.channelOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
    }
  }

  els.saveOrderConfigModalShow.on("click", function(e) {
    e.preventDefault();
    if(!el.valid()){
      return;
    }else{
      setValueForHiddenVariables();
      $("#save-confirmation-modal").appendTo("body").modal("show");
    }

  });

  function setValueForHiddenVariables(){
    els.addressValidationValueHidden.val("");
    els.addressValidationTextHidden.val("");
    els.shippingMethodValueHidden.val("");
    els.shippingMethodTextHidden.val("");

    els.addressValidationValueHidden.val(els.defaultAddressValidationLevelSelect.find("option:selected").val());
    els.addressValidationTextHidden.val(els.defaultAddressValidationLevelSelect.find("option:selected").text());
    els.shippingMethodValueHidden.val(els.defaultShippingMethodSelect.find("option:selected").val());
    els.shippingMethodTextHidden.val(els.defaultShippingMethodSelect.find("option:selected").text());
  }

  els.einNumber.inputmask({mask: '99-9999999',  jitMasking: true});

  $(".save-order-config-cofirmed").on("click", function(e){
    e.preventDefault();
    save({url: saveURL,success: saveSuccess, error: saveError});
  });

  function save({url,success,error}) {
    submitModalFlow.showLoadingModal();
    $.ajax({
      data: new FormData($('#order-config').get(0)),
      url: url,
      processData: false,
      contentType: false,
      dataType: "JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function saveSuccess(data) {
    if(data.response == "success") {
      EditChecker.setPageClean();
      submitModalFlow.showSuccessModal();
      setTimeout(function() {
        location.href = `${detailPageUrl}`;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

    } else {
      submitModalFlow.showFailureModal();
    }
  }

  function saveError() {
    submitModalFlow.hideAllModals();
  }


  els.internalGracePeriodContainer.on('change', function(e){
    e.preventDefault();
    setInternalCutOffTimeDynamically();
  });

  function setInternalCutOffTimeDynamically(){
    els.interalOrderCutOffTime.text(calculateCutOffTime(els.internalGracePeriodHours.val(), els.internalGracePeriodMinutes.val()));
  }

  els.channelGracePeriodContainer.on('change', function(e){
    e.preventDefault();
    setChannelCutOffTimeDynamically();
  });

  function setChannelCutOffTimeDynamically(){
    els.channelOrderCutOffTime.text(calculateCutOffTime(els.channelGracePeriodHours.val(), els.channelGracePeriodMinutes.val()));
  }

  function setDeclaredValueOrderConfig(){
    instantiateSwitchery(els.orderDeclaredValueToggleSwitch);
    if(orderDeclaredValue.cdmValue==="1"){
      setSwitchery(els.orderDeclaredValueToggleSwitch, true);       
    }else{
      setSwitchery(els.orderDeclaredValueToggleSwitch, false);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/orderConfiguration/orderConfiguration.js